import React, { useState } from 'react';
import ImageBrowserModal from './ImageBrowserModal';
import './ImagePicker.css';

const ImagePicker = ({ label, value, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectImage = (imagePath) => {
    onChange(imagePath); // Meghívjuk a szülőtől kapott onChange függvényt
    setIsModalOpen(false);
  };

  return (
    <div className="image-picker-container">
      <label>{label}</label>
      <div className="image-preview-wrapper">
        <img 
          src={value || 'https://via.placeholder.com/150'} 
          alt="Előnézet" 
          className="image-preview"
        />
        <button type="button" onClick={() => setIsModalOpen(true)} className="browse-button">
          Tallózás
        </button>
      </div>
      
      {isModalOpen && (
        <ImageBrowserModal 
          onSelect={handleSelectImage} 
          onClose={() => setIsModalOpen(false)} 
        />
      )}
    </div>
  );
};

export default ImagePicker;